export default {
    'name': '76',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M7 64H57C57.6 64 58 63.6 58 63V1C58 0.4 57.6 0 57 0H7C6.4 0 6 0.4 6 1V63C6 63.6 6.4 64 7 64ZM14 62H8V2H14V62ZM16 62H56V2H52V17.4L46 11.4L40 17.4V2H16V62ZM42 2H50V12.6L46 8.60001L42 12.6V2ZM20 43H52V21H20V43ZM50 41H22V23H50V41ZM46 31H26V33H46V31ZM26 35H46V37H26V35ZM12 4H10V60H12V4ZM35 27H37V29H35V27ZM33 27H31V29H33V27ZM39 29V27H41V29H39Z\' fill=\'#026958\'/>'
}
